import onChange from 'on-change';
import disablePageScroll from '../helpers/disablePageScroll';
import enablePageScroll from '../helpers/enablePageScroll';

const TOGGLE_EL_SELECTOR = '[data-mobile-nav-toggle]';
const NAVIGATION_VISIBLE_CLASS = 'visible';
const MOBILE_NAV_SELECTOR = '[data-mobile-nav]';
const BACKDROP_SELECTOR = '[data-mobile-nav-backdrop]';
const NAV_LINK_SELECTOR = '[data-mobile-nav-link]';

const toggleNavigationVisibility = (navigationEl, isVisible) => {
	navigationEl.classList.toggle(NAVIGATION_VISIBLE_CLASS, isVisible);

	if (isVisible) {
		disablePageScroll();
	} else if (
		!document.querySelector('.modal').classList.contains('modal--show')
	) {
		enablePageScroll();
	}
};

export default (initialState) => {
	const state = {
		isVisible: false,
		...initialState,
	};

	const navigationEl = document.querySelector(MOBILE_NAV_SELECTOR);

	const watchedState = onChange(state, (path, value) => {
		switch (path) {
			case 'isVisible':
				toggleNavigationVisibility(navigationEl, value);
				break;
			default:
				break;
		}
	});

	const handleToggleClick = () => {
		watchedState.isVisible = true;
	};

	const handleBackdropClick = (evt) => {
		if (evt.target === document.querySelector(MOBILE_NAV_SELECTOR)) {
			watchedState.isVisible = false;
		}
	};

	const handleNavLinkClick = () => {
		watchedState.isVisible = false;
	};

	const toggleEls = document.querySelectorAll(TOGGLE_EL_SELECTOR);
	//const backdropEl = navigationEl.querySelector(BACKDROP_SELECTOR);
	const navLinks = navigationEl.querySelectorAll(NAV_LINK_SELECTOR);

	toggleEls.forEach((el) => el.addEventListener('click', handleToggleClick));
	navLinks.forEach((el) => el.addEventListener('click', handleNavLinkClick));

	navigationEl.addEventListener('click', handleBackdropClick);

	toggleNavigationVisibility(navigationEl, watchedState.isVisible);
};
